var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vTree',{ref:"tree",staticClass:"tablelist-tree-search",attrs:{"data":_vm.handleTraversalData(_vm.data,true),"toggleActive":false,"multiple":""},on:{"on-active-change":_vm.handleSearch}})
}
var staticRenderFns = []

export { render, staticRenderFns }